import IGeoCoordinate from "./IGeoCoordinate";

export default interface INotification {
    type: NotificationType;
    leadId?: number;
    dealId?: number;
    name: string;
    address?: string;
    dueDate?: Date;
    subject?: string;
    centerPoint: IGeoCoordinate;
    createdDate: Date;
    modifiedDate: Date;
}

export enum NotificationType {
    Lead,
    Deal,
}